module.exports = __webpack_public_path__ + "img/join-me.0b31e02d.png";